module.exports = __webpack_public_path__ + "img/299.7409ef3c.svg";